// import { fetchModule } from "../utils/fetchingData";

const API = {
  setPhone: "users_duplicatemobilenumber",
  verifyCode: "users_validatetemporary",
  signup: "users_register",
  login: "users_login",
  forgetPass: "users_forgetpass",
  getCities: "campaign_getcity",
  getNumber: "chance_getrandomnumber",
  insertNumber: "chance_insertfromuser",
  setStautsAPI: "chance_updatecondition",
  completeForm: "chance_completetheinformation",
  getState: "campaign_getallostan",
  getCityFromState: "campaign_getallshahresatn",
  setFollowUpStatus: "chance_updateconditionfollowup",
  getHistory: "chance_getall"
};
// const API = Object.keys(APIConfig).reduce((ob, current) => {
//   ob[current] = async function(payload, segment) {
//     let { url, ...conf } = APIConfig[current].config;
//     url = segment ? url + `/${segment.join("/")}` : url;
//     try {
//       return fetchModule({
//         url: url,
//         ...conf,
//         ...payload
//       });
//     } catch (error) {
//       throw new Error(error);
//     }
//   };
//   return ob;
// }, {});
export default API;
